/* Terra Sacra — UX layer (test theme). Loaded from the "ts_ux" section in the header group. */
(function () {
  'use strict';

  /* ---------- 1. Sorting: keep four clear options ---------- */
  var KEEP_SORT = {
    'best-selling': 'Best selling',
    'price-ascending': 'Price: low to high',
    'price-descending': 'Price: high to low',
    'created-descending': 'Newest'
  };

  function pruneSort() {
    document.querySelectorAll('select[name="sort_by"]').forEach(function (select) {
      if (select.dataset.tsPruned === '1') return;
      Array.prototype.slice.call(select.options).forEach(function (option) {
        if (KEEP_SORT[option.value]) {
          option.textContent = KEEP_SORT[option.value];
        } else if (!option.selected) {
          option.remove();
        }
      });
      select.dataset.tsPruned = '1';
    });
  }

  /* ---------- 2. Sticky Add to cart on mobile product pages ---------- */
  function initStickyAtc() {
    var form = document.querySelector('product-form.product-form form[data-type="add-to-cart-form"]');
    if (!form || document.querySelector('.ts-sticky-atc')) return;
    var mainBtn = form.querySelector('.product-form__submit');
    if (!mainBtn) return;

    var titleEl = document.querySelector('.product__title h1, .product__title h2, h1');
    var priceEl = document.querySelector('.product__info-container .price__regular .price-item--regular, .product__info-container .price-item--last, .product__info-container .price-item');

    var bar = document.createElement('div');
    bar.className = 'ts-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="ts-sticky-atc__info">' +
      '<span class="ts-sticky-atc__title"></span>' +
      '<span class="ts-sticky-atc__price"></span>' +
      '</div>' +
      '<button type="button" class="ts-sticky-atc__btn" tabindex="-1">Add to cart</button>';
    bar.querySelector('.ts-sticky-atc__title').textContent = titleEl ? titleEl.textContent.trim() : '';
    document.body.appendChild(bar);

    var stickyBtn = bar.querySelector('.ts-sticky-atc__btn');
    var priceOut = bar.querySelector('.ts-sticky-atc__price');

    function sync() {
      var p = document.querySelector('.product__info-container .price:not(.price--on-sale) .price__regular .price-item, .product__info-container .price--on-sale .price-item--sale, .product__info-container .price-item');
      priceOut.textContent = p ? p.textContent.trim() : (priceEl ? priceEl.textContent.trim() : '');
      var unavailable = mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true';
      stickyBtn.disabled = unavailable;
      var label = mainBtn.querySelector('span');
      stickyBtn.textContent = label && label.textContent.trim() ? label.textContent.trim() : 'Add to cart';
    }
    sync();

    stickyBtn.addEventListener('click', function () {
      if (stickyBtn.disabled) return;
      mainBtn.click();
    });

    var ticking = false;
    function check() {
      ticking = false;
      /* Theme preview only: sit above Shopify's preview bar so it stays visible */
      var pbar = document.getElementById('PBarNextFrameWrapper');
      bar.style.bottom = pbar && pbar.offsetHeight ? pbar.offsetHeight + 'px' : '';
      var show = window.innerWidth < 750 && mainBtn.getBoundingClientRect().bottom < 0;
      if (show === bar.classList.contains('is-visible')) return;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      stickyBtn.tabIndex = show ? 0 : -1;
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(check);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    check();

    var info = document.querySelector('.product__info-container');
    if (info && 'MutationObserver' in window) {
      new MutationObserver(sync).observe(info, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    }
  }

  /* ---------- 3. Cart: save the optional ship date as a cart attribute ---------- */
  var ATTR = 'Preferred ship date';
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('[data-ts-shipdate]')) return;
    var attributes = {};
    attributes[ATTR] = input.value || '';
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).catch(function () {});
  });

  /* ---------- 4. Collection intro: three lines + "Read more" on mobile ---------- */
  function initReadMore() {
    document.querySelectorAll('.collection-hero__description').forEach(function (desc) {
      if (desc.dataset.tsClamp === '1') return;
      desc.dataset.tsClamp = '1';
      desc.classList.add('ts-clamp');
      if (desc.scrollHeight <= desc.clientHeight + 4) {
        desc.classList.remove('ts-clamp');
        return;
      }
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ts-readmore';
      btn.textContent = 'Read more';
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var open = desc.classList.toggle('is-open');
        btn.textContent = open ? 'Show less' : 'Read more';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      desc.insertAdjacentElement('afterend', btn);
    });
  }

  /* ---------- 5. Product cards: add to cart without leaving the page ----------
     - Single-size products: the card button adds straight to the cart.
     - Multi-size products: size pills on the card (e.g. 500 ml / 250 ml) + Add to cart.
     - Confirmation is a small toast ("Added to cart · View cart"); the cart drawer
       only opens if the shopper taps "View cart". Name and photo still open the product. */
  var ROOT = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  /* Size pills show the US measure, the part before the parentheses:
     "16.9 fl oz (500 ml)" -> "16.9 fl oz". The full name stays in the tooltip and for screen readers. */
  function shortLabel(value) {
    var v = value || '';
    var i = v.indexOf(' (');
    return i > 0 ? v.slice(0, i) : v;
  }

  function bottomOffset() {
    var offset = 16;
    var pbar = document.getElementById('PBarNextFrameWrapper');
    if (pbar && pbar.offsetHeight) offset += pbar.offsetHeight;
    var sticky = document.querySelector('.ts-sticky-atc.is-visible');
    if (sticky) offset += sticky.offsetHeight;
    return offset;
  }

  function toast(message, ok) {
    var t = document.querySelector('.ts-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'ts-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      document.body.appendChild(t);
    }
    t.innerHTML = '';
    var msg = document.createElement('span');
    msg.className = 'ts-toast__msg';
    msg.textContent = (ok ? '✓ ' : '') + message;
    t.appendChild(msg);
    if (ok) {
      var view = document.createElement('button');
      view.type = 'button';
      view.className = 'ts-toast__link';
      view.textContent = 'View cart';
      view.addEventListener('click', function () {
        t.classList.remove('is-visible');
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
        else window.location.href = ROOT + 'cart';
      });
      t.appendChild(view);
    }
    t.classList.toggle('is-error', !ok);
    t.style.bottom = bottomOffset() + 'px';
    t.classList.add('is-visible');
    window.clearTimeout(t.tsTimer);
    t.tsTimer = window.setTimeout(function () {
      t.classList.remove('is-visible');
    }, 4000);
  }

  function renderCartSections(sections) {
    if (!sections) return;
    var parse = function (html) {
      return new DOMParser().parseFromString(html, 'text/html');
    };
    var drawer = document.querySelector('cart-drawer');
    if (sections['cart-drawer']) {
      var src = parse(sections['cart-drawer']).querySelector('#CartDrawer');
      var dst = document.getElementById('CartDrawer');
      if (src && dst) {
        dst.innerHTML = src.innerHTML;
        if (drawer) {
          drawer.classList.remove('is-empty');
          var overlay = document.getElementById('CartDrawer-Overlay');
          if (overlay && typeof drawer.close === 'function') overlay.addEventListener('click', drawer.close.bind(drawer));
        }
      }
    }
    if (sections['cart-icon-bubble']) {
      var bubbleSrc = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubbleSrc && bubble) bubble.innerHTML = bubbleSrc.innerHTML;
    }
  }

  function setButtonLabel(btn, text) {
    var label = btn.querySelector('.sr-only') || btn;
    if (!btn.dataset.tsLabel) btn.dataset.tsLabel = label.textContent.trim();
    label.textContent = text;
  }

  function addToCart(variantId, btn) {
    if (!variantId || (btn && btn.dataset.tsBusy === '1')) return;
    if (btn) {
      btn.dataset.tsBusy = '1';
      btn.setAttribute('aria-disabled', 'true');
      setButtonLabel(btn, 'Adding…');
    }
    var sections = document.querySelector('cart-drawer') ? ['cart-drawer', 'cart-icon-bubble'] : ['cart-icon-bubble'];
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) throw data;
          return data;
        });
      })
      .then(function (data) {
        renderCartSections(data.sections);
        if (btn) setButtonLabel(btn, 'Added ✓');
        toast('Added to cart', true);
      })
      .catch(function (error) {
        toast((error && (error.description || error.message)) || "Sorry, we couldn't add this item.", false);
        if (btn) setButtonLabel(btn, btn.dataset.tsLabel || 'Add to cart');
      })
      .then(function () {
        if (!btn) return;
        btn.dataset.tsBusy = '';
        btn.removeAttribute('aria-disabled');
        window.setTimeout(function () {
          if (btn.dataset.tsLabel) setButtonLabel(btn, btn.dataset.tsLabel);
        }, 1800);
      });
  }

  /* Single-size cards: take over the card form so the page stays where it is */
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.closest || !form.closest('.product-card-wrapper .quick-add')) return;
      var idInput = form.querySelector('[name="id"]');
      if (!idInput || !idInput.value) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      addToCart(idInput.value, form.querySelector('.quick-add__submit'));
    },
    true
  );

  /* Multi-size cards: replace "See options" with size pills + Add to cart */
  var productCache = {};
  function fetchProduct(href) {
    var clean = href.split('?')[0].split('#')[0];
    if (!productCache[clean]) {
      productCache[clean] = fetch(clean + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
        if (!r.ok) throw new Error('product');
        return r.json();
      });
    }
    return productCache[clean];
  }

  function buildVariantPicker(link) {
    if (link.dataset.tsVariants) return;
    link.dataset.tsVariants = 'loading';
    fetchProduct(link.getAttribute('href'))
      .then(function (product) {
        var variants = product.variants || [];
        if (!variants.length || (product.options || []).length !== 1 || variants.length > 4 || !link.isConnected) {
          link.dataset.tsVariants = 'skip';
          return;
        }
        var wrapper = link.parentElement;
        var card = link.closest('.card-wrapper');
        var priceEl = card ? card.querySelector('.card-information .price__regular .price-item--regular') : null;
        var optionName = (product.options[0] && (product.options[0].name || product.options[0])) || 'Size';
        var selected = null;
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].available) {
            selected = variants[i];
            break;
          }
        }

        var group = document.createElement('div');
        group.className = 'ts-variants';
        group.setAttribute('role', 'radiogroup');
        group.setAttribute('aria-label', typeof optionName === 'string' ? optionName : 'Size');

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'quick-add__submit button button--full-width button--secondary ts-qa';
        btn.innerHTML = '<span class="sr-only">Add to cart</span>';

        function select(v) {
          selected = v;
          group.querySelectorAll('.ts-variant').forEach(function (pill) {
            var on = pill.dataset.id === String(v.id);
            pill.classList.toggle('is-selected', on);
            pill.setAttribute('aria-checked', on ? 'true' : 'false');
          });
          if (priceEl) priceEl.textContent = money(v.price);
        }

        variants.forEach(function (v) {
          var pill = document.createElement('button');
          pill.type = 'button';
          pill.className = 'ts-variant';
          pill.setAttribute('role', 'radio');
          pill.setAttribute('aria-checked', 'false');
          pill.dataset.id = String(v.id);
          pill.textContent = shortLabel(v.option1 || v.title);
          pill.title = (v.option1 || v.title) + (v.available ? '' : ' — sold out');
          pill.setAttribute('aria-label', pill.title);
          if (!v.available) {
            pill.disabled = true;
            pill.classList.add('is-unavailable');
          }
          pill.addEventListener('click', function () {
            select(v);
          });
          group.appendChild(pill);
        });

        if (selected) {
          select(selected);
          btn.addEventListener('click', function () {
            addToCart(selected.id, btn);
          });
        } else {
          btn.disabled = true;
          btn.querySelector('.sr-only').textContent = 'Sold out';
        }

        wrapper.insertBefore(group, link);
        wrapper.replaceChild(btn, link);
      })
      .catch(function () {
        link.dataset.tsVariants = 'error';
      });
  }

  var variantObserver =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              variantObserver.unobserve(entry.target);
              buildVariantPicker(entry.target);
            });
          },
          { rootMargin: '400px 0px' }
        )
      : null;

  function initCardVariants() {
    document.querySelectorAll('.product-card-wrapper .quick-add a.quick-add__submit[href*="/products/"]').forEach(function (link) {
      if (link.dataset.tsVariants || link.dataset.tsObserved) return;
      link.dataset.tsObserved = '1';
      if (variantObserver) variantObserver.observe(link);
      else buildVariantPicker(link);
    });
  }

  /* ---------- boot ---------- */
  var scheduled = false;
  function refresh() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      pruneSort();
      initCardVariants();
    });
  }

  function boot() {
    pruneSort();
    initStickyAtc();
    initReadMore();
    initCardVariants();
    if ('MutationObserver' in window) {
      new MutationObserver(refresh).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
